export default {
  title: 'Bezahle, wenn du soweit bist',
  description: 'Die Bezahlung kann jederzeit während oder nach dem Essen erfolgen. Wenn du die Rechnung nicht vor dem Verlassen des Restaurants bezahlst, kann das Restaurant den Gesamtbetrag zzgl. Säumnisgebühr abrechnen und zusätzliche Gebühren als Busse erheben.',
};